// Direct imports
import { TraceBehavior } from "./tracebehavior";

// 2024
// Author: Aaron Post

// This class is a placeholder / data container for unsupported behaviors (interaction, colliders, etc). This preserves data on re-export.
export class GenericBehavior extends TraceBehavior {
}